import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import { Box, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { TRACKING_CARD_GREEN_SX } from "./trackingStyles";

const ScheduleRow = ({ icon, label, value }) => (
  <Stack direction="row" spacing={1.5} alignItems="flex-start">
    <Box
      sx={{
        p: 0.75,
        borderRadius: 1.5,
        bgcolor: "#E8F5E9",
        color: "success.dark",
        display: "flex",
        flexShrink: 0,
      }}
    >
      {icon}
    </Box>
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="caption" color="text.secondary" display="block">
        {label}
      </Typography>
      <Typography variant="body2" fontWeight={700} lineHeight={1.45}>
        {value}
      </Typography>
    </Box>
  </Stack>
);

ScheduleRow.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

const RequestScheduleCard = ({ schedule }) => (
  <Box sx={{ ...TRACKING_CARD_GREEN_SX, p: { xs: 2, md: 2.5 }, height: "100%" }}>
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
      <ScheduleOutlinedIcon sx={{ color: "success.main" }} />
      <Typography variant="subtitle1" fontWeight={800} color="success.dark">
        زمان‌بندی تقریبی
      </Typography>
    </Stack>

    <Stack spacing={2}>
      <ScheduleRow
        icon={<TimelineOutlinedIcon fontSize="small" />}
        label="مرحله فعلی"
        value={schedule.currentStage || "—"}
      />
      <ScheduleRow
        icon={<EventAvailableOutlinedIcon fontSize="small" />}
        label="زمان تکمیل این مرحله"
        value={schedule.stageCompletionLabel || "—"}
      />
      <ScheduleRow
        icon={<ScheduleOutlinedIcon fontSize="small" />}
        label="زمان تقریبی بهره‌برداری"
        value={schedule.commissioningRangeLabel || "—"}
      />
    </Stack>

    {schedule.scheduleNote ? (
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mt: 2, display: "block", lineHeight: 1.6 }}
      >
        {schedule.scheduleNote}
      </Typography>
    ) : null}
  </Box>
);

RequestScheduleCard.propTypes = {
  schedule: PropTypes.object.isRequired,
};

export default RequestScheduleCard;
